<template>
    <div>
        <div class="d-flex flex-row justify-content-center gap-3 mb-8">
            <h2 class="text-center mb-0">{{ __('statistics.best_brands_for_store', {storeName: $page.props.store.attributes.name}) }}</h2>
            <Tooltip class="w-300px" position="left">
                <template #trigger>
                    <i class="text-primary cursor-pointer fas fa-info-circle fa-lg"/>
                </template>
                <div v-html="__('statistics.info_best_brand')"></div>
            </Tooltip>
        </div>
        <div class="table-responsive">
            <table class="table table-hover table-row-dashed align-middle gs-0 gy-4 my-0">
                <thead class="thead-light">
                <tr class="text-left">
                    <th class="w-3">
                        <TableSort field="impressions" :value="sort" @input="updateSort">
                            {{ __('statistics.rank') }}
                        </TableSort>
                    </th>
                    <th>
                        <TableSort field="brand" :value="sort" @input="updateSort">
                            {{ __('general.brand') }}
                        </TableSort>
                    </th>
                    <th>
                        <TableSort field="impressions" :value="sort" @input="updateSort">
                            {{ __('statistics.impressions') }}
                        </TableSort>
                    </th>
                    <th>
                        <TableSort field="clicks" :value="sort" @input="updateSort">
                            {{ __('statistics.clicks') }}
                        </TableSort>
                    </th>
                    <th>
                        <TableSort field="ctr" :value="sort" @input="updateSort">
                            {{ __('statistics.ctr') }}
                        </TableSort>
                    </th>
                </tr>
                </thead>
                <tbody>

                <tr v-for="singleStatistic in statistics.data" class="text-left">
                    <td class="w-3">
                        <span>{{ singleStatistic.rank }}</span>
                    </td>
                    <td>
                        <span>{{ getSegmentValue(singleStatistic.brand) }}</span>
                    </td>
                    <td>
                        <span class="d-block mt-2">
                            {{ singleStatistic.impressions }}
                        </span>
                    </td>
                    <td>
                        <span class="d-block mt-2">
                            {{ singleStatistic.clicks }}
                        </span>
                    </td>
                    <td>
                        <span class="d-block mt-2">
                            {{ roundCtr(singleStatistic.impressions, singleStatistic.clicks) }}%
                        </span>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <Pagination v-if="lastRow !== maxSearchResults"
                    :pagination="statistics"
                    :inertia-options="{
                            only: ['statistics']
                        }"
                    disable-when-one-page
                    scroll-to-top
        />
    </div>
</template>

<script>
import TableSort from '@components/Table/TableSort.vue';
import Pagination from '@components/TableComponents/Pagination.vue';
import {rewriteUrlNew} from '@composables/rewriteUrlNew';
import Tooltip from '@components/Tooltip.vue';

export default {
    components: {Tooltip, Pagination, TableSort},
    props: {
        statistics: {
            types: [Object, Array],
        },
        maxSearchResults: Number,
    },

    data() {
        return {
            sort: {}
        }
    },

    computed: {
        lastRow() {
            return this.statistics.total;
        },

        perPage() {
            return this.statistics.per_page;
        },

        page() {
            return this.statistics.page;
        },
    },

    methods: {
        shortName(name) {
            if (name.length < 42) {
                return name;
            }

            return name.substring(0, 42) + '...';
        },
        getSegmentValue(segment) {
            if (segment) {
                return this.shortName(segment).charAt(0).toUpperCase() + this.shortName(segment).slice(1);
            } else {
                return this.__('general.unknown');
            }
        },
        roundCtr(impressions, clicks) {
            if (clicks === 0) {
                return 0;
            }
            return (clicks / impressions).toFixed(3);
        },
        updateSort(sortParams) {
            this.sort = sortParams;
            rewriteUrlNew('sort', sortParams);
            this.$emit('reloadStats');
        },
        goToFirstPageIfNeeded() {
            if (this.statistics.current_page > this.statistics.last_page) {
                rewriteUrlNew('page', 1);
                rewriteUrlNew('per_page', this.statistics.per_page);
                this.$emit('reloadStats');
            }
        },
    },
    watch: {
        'statistics.last_page'() {
            this.goToFirstPageIfNeeded();
        },
    }
};
</script>
